import { Col, Modal, Row } from "react-bootstrap";
import useMultiLanguage from "../../../hook/useMultiLanguage";
import TableGrouping from "../../components/table-grouping/TableGrouping";
import { GroupButton } from "../../components/GroupButton";
import { REPORT_NANG_LUONG_COLUMNS } from "../constants/reportConsts";
import { useContext } from "react";
import AppContext from "../../../AppContext";

const DialogPrintReportSalaryIncrease = (props: any) => {
  const {
    open,
    columns = [],
    dateSearch = {},
    data = [],
    handleClose = () => { }
  } = props;

  const { setPageLoading } = useContext(AppContext);
  const { lang } = useMultiLanguage();

  const handlePrint = () => {
    let style = `
          @media print {
            body { zoom: 0.65; margin: 20px 20px }
            table { width: 100%; border-collapse: collapse; }
            th, td { border: 1px solid black; text-align: center; }
            
            .container-title {
                position: relative;
                padding-top: 1.25rem;
                margin-bottom: 1.25rem;
            }
    
            .title-table-print {
                font-weight: bold;
                text-transform: uppercase;
                font-size: 1.75rem;
                text-align: center;
                margin: 0px;
            }

            .title-time-print {
                font-style: italic;
                font-size: 1.15rem;
                margin: 0px;
                display: flex;
                justify-content: center;
                align-items: center;
            }

            .container-header {
                display: flex;
                justify-content: space-between;
                margin-left: 1.25rem;
                margin-top: 3rem;
            }

            .title-header {
                font-weight: bold;
                font-size: 1.35rem;
                text-align: center;
                margin: 0px;
            }

            .text-left {
                text-align: left !important;
            }
            
            .container-footer {
                margin-top: 30px;
                margin-bottom: 100px;
            }

            .time-footer {
                text-align: end;
                font-style: italic;
                margin-bottom: 10px;
            }

            .footer {
                display: flex;
                justify-content: space-between;
            }
            
            .title-footer {
                text-align: center;
                font-weight: bold;
                margin: 0;
            }

            .span-footer {
                text-align: center;
                font-style: italic;
                margin: 0;
            }

            .text-uppercase {
                text-transform: uppercase;
            }

            @page {
                margin: 20px !important; 
            }
          }
        `;
    const content = document.getElementById("content-print");
    if (content) {
      const printWindow = window.open('', '_blank', 'width=800,height=600');
      if (printWindow) {
        printWindow.document.open();
        printWindow.document.write(`
          <html>
            <head>
              <title>Bang_Bao_Cao_Nang_Luong</title>
              <style>${style}</style>
            </head>
            <body onload="window.print(); window.close();">
              ${content.innerHTML}
            </body>
          </html>
        `);
        printWindow.document.close();
      }
    }
  };

  if (!open) return <></>

  return (
    <Modal
      show={open}
      onHide={() => {
        handleClose();
      }}
      backdrop="static"
      size="xl"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {lang("PRINT_TIMEKEEPING_TABLE")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="spaces py-0">
        <iframe
          id="ifmcontentstoprint"
          style={{
            height: "0px",
            width: "0px",
            position: "absolute",
          }}
        ></iframe>
        <div className="time-sheets-print">
          <Row id="content-print" className="px-4">
            <div className="container-header ms-5 mt-5">
              <div>
                <p className="fw-bold text-uppercase fs-3 text-center m-0 title-header">
                  {(data[0] as any)?.soYTe || ""}
                </p>
                <p className="fw-bold text-uppercase fs-3 text-center m-0 title-header">
                  {(data[0] as any)?.tenBenhVien || ""}
                </p>
              </div>
              <div></div>
            </div>

            <Col xs={12}>
              <div className="container-title relative pt-5 mb-3">
                <p className='fw-bold text-uppercase fs-1 text-center m-0 title-table-print'>
                  {REPORT_NANG_LUONG_COLUMNS.find((report) => report.tab === dateSearch.tab)?.name1 || ""}
                </p>
                <p className='fw-bold text-uppercase fs-1 text-center m-0 title-table-print'>
                  {REPORT_NANG_LUONG_COLUMNS.find((report) => report.tab === dateSearch.tab)?.name2 || "Báo cáo nâng lương năm"} {new Date().getFullYear()}
                </p>
                <div className="fs-5 text-center italic m-0 flex justify-content-center align-items-center title-time-print">
                  (Kèm theo Thông báo số <p style={{ width: "60px" }}></p>/TB-{(data[0] as any)?.tenVietTat} ngày<p style={{ width: "20px" }}></p>tháng<p style={{ width: "20px" }}></p>năm {new Date().getFullYear()} của {(data[0] as any)?.tenBenhVien || ""})
                </div>
              </div>
              <TableGrouping
                id="reportDetail"
                columns={columns || []}
                data={data || []}
                className="table-custom"
                showTotalRow={false}
                columnsTotal={[]}
                prefixDataField="data"
                prefixTitleField="phongBanText"
              />
            </Col>
            {/* <div className="container-footer">
              <div className="time-footer">......, Ngày ..... tháng ..... năm ....</div>
              <div className="footer">
                <div>
                  <p className="title-footer">Người chấm công</p>
                  <p className="span-footer">(Ký, Họ tên)</p>
                </div>
                <div>
                  <p className="title-footer">Phụ trách khoa, phòng</p>
                  <p className="span-footer">(Ký, Họ tên)</p>
                </div>
                <div>
                  <p className="title-footer">Người duyệt</p>
                  <p className="span-footer">(Ký, Họ tên)</p>
                </div>
              </div>
            </div> */}
          </Row>
        </div>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-center">
        <GroupButton
          handleEvent={() => {
            handlePrint();
          }}
        >
          {lang("BTN.PRINT")}
        </GroupButton>
        <GroupButton
          type="btn-cancel"
          handleCloseUpdateDialog={() => {
            handleClose();
          }}
        />
      </Modal.Footer>
    </Modal>
  )
}
export default DialogPrintReportSalaryIncrease;